import { useState } from "react";
import { LangContext } from "./LangContext";
import { content } from "@/data/content";
import CursorDot from "./CursorDot";
import Header from "./Header";
import Hero from "./Hero";
import Intro from "./Intro";
import WhatWeDo from "./WhatWeDo";
import ImageBreak from "./ImageBreak";
import Network from "./Network";
import Philosophy from "./Philosophy";
import MarqueeBand from "./MarqueeBand";
import ForBrands from "./ForBrands";
import Footer from "./Footer";

export default function Landing() {
  const [lang, setLang] = useState("en");
  const t = content[lang];

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <div className="cursor-none-desktop relative min-h-screen bg-background text-foreground antialiased">
        <CursorDot />
        <Header />
        <main>
          <Hero />
          <Intro />
          <WhatWeDo />
          <ImageBreak />
          <Network />
          <Philosophy />
          <MarqueeBand />
          <ForBrands />
        </main>
        <Footer />
      </div>
    </LangContext.Provider>
  );
}
